module.exports = __webpack_public_path__ + "static/media/brand-detail-page-banner-desktop.cf5c5f84.png";